"use client"

import type React from "react"

interface CounterProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  className?: string
}

const Counter: React.FC<CounterProps> = ({ value, onChange, min = 0, max = 99, className }) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = parseInt(e.target.value, 10)
    if (isNaN(val)) val = min
    if (val < min) val = min
    if (val > max) val = max
    onChange(val)
  }

  return (
    <div className={`newProducerInputGroup flex items-center  ${className || ''}`}>
        <input
          type="text"
          value={value}
          onChange={handleInputChange}
          className="bg-[#D22630] border border-gray-300 rounded-full rounded-s-none border-l-0 px-1.5 py-1.5 mb-6 transition-all duration-200 shadow-sm hover:shadow-md w-[40px] h-[50px] text-[16px] font-[600] text-white text-center"
        />
    </div>
  )
}

export default Counter